<div *ngIf="percent !== undefined" [class]="'progress-bar--' + getColorClass()" class="progress-bar">
  <mat-progress-bar
    matTooltipPosition="above"
    [matTooltip]="tooltipContent"
    [value]="uploadPercentage$ | async"
    mode="determinate"
  ></mat-progress-bar>
  <span *ngIf="showPercent && percent !== undefined" class="progress-bar__value">{{ percent }}%</span>
</div>
